var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg389(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 794,
    height: 1000,
    viewBox: "0 0 794 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-width: 8px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.048,560.069c84.876,60.288,116.966,93.182,116.966,93.182L786.261,995.356h-136.2S610.112,865.677,590.189,805.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.8,667.183C627.53,704.805,592.639,745.5,564.932,784.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.036,207.5c-0.916,11.739-16.349,142.48-12.937,170.21S351.37,448.071,419.442,484.52c82.75,1.377,134.351-17.976,148.585-43.344,14.043-25.026,46-66.25,71.164-144.429"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.857,223.037c-32.309,9.02-27.07,87.135-4.111,102.748"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.945,306.09c39.019,26.912-14.976,97.391-42.51,91.743"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.9,394.535c29.645,33.435,80.932,36.708,114.474,31.162"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.008,354.489c11.458-62.808,18.295-104.648-4.643-106.811,9.1-69.3-4.753-65.848-24.74-72.673"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.882,292.849c27.607-27.045,11.463-94.84,53.244-94.84,0-11.726-26.5-26.568-36.65-26.568"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.418,147.106c9-31.095,14.06-56.315-.2-87.483"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.454,138.532C645.791,73.317,539.852-3.141,481.413,6.244,454.321,10.6,435.7,20.343,414.8,26.316s-53.92,15.395-75.84,17.028c17.817,6.844,18.413,6.965,36.23,13.808"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.474,69.412c-58.138,5.226-108.51,72.092-89.743,128.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.149,170.682c0.632,12.911-19.886,31.2-38.233,42.717,44.429,0,85.316-12.215,121.532-41.066"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.092,170.682c-1.8-17.441-11.785-36.15-27.154-45.207-68.426-33.209-105.864,50.907-164.945,50.907,0,0,17.759-36.339,15.065-45.318"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.409,135.853c26.706-3.554,61.5,9.776,83.523,26.686"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.657,184.4c-1.706,13.652-2.835,19.954-4.252,29.929-28.988,0-46.367,55.425-48.961,78.124"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.76,475.232c-7.83,12.086-7.088,60.975,4.064,70.789"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.9,454.667c-8.762,24.11-9.024,47.968-27.083,69.039"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.117,504.644c16.011,13.012,42.143,38.206,58.154,51.218-20.584,48.959-36.022,94.869-56.606,143.828-32.5-64.44-27.823-68.377-54.357-68.377"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.518,545.221c-30.189,21.108-57.387,42.223-87.576,63.331,2.173,20,1.347,40.016,3.52,60.02L395.8,690.239,383,992"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.864,518.576c16.225,22.033,42.458,57.858,58.683,79.892l-8.059,51.6c9.961,10.11,17.926,18.224,27.887,28.334"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.437,489.164c-11,6.726-41.231,19.5-52.231,26.226-4.443,51.827-10.77,100.147-14.653,152.534C302.56,652.916,338.956,616.342,358,612c7.118,4.438,12.6,5.921,15.2,9.714"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.717,524.768c-27.858,11.4-78.134,36.268-78.134,36.268s-24.417,23.466-37.472,37.63"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.893,586.479c-2.742-71.312,94.829-163.9,94.829-163.9-5.682-5.842-10.514-10.92-28.819-6.17-10.72,2.781-26.739,15.868-42.9,25.843"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.073,429.483c0.282-52.218.844-144.254,0.844-156.671-4.456-.956-17.106.369-23.473,7.374-5.411,7.959-23.565,75.557-24.764,92.879"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.585,373.065c-7.484-36.888-14.185-73.019-21.669-109.907-8.871,1.418-15.938,5.972-21.668,13.932-4.457,8.915,3.095,97.033,3.095,116.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.688,390.964s-20.834-66.61-29.7-101.458c-1.768.527-10.922,5.789-15.075,10.8-9.308,11.238,5.2,73.025,14.063,112.913"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.494,442.879c-9.914-20.078-51.181-85.7-25.242-107.311,11.892,19.559,32.149,55.089,44.04,74.649"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.329,425.316L161.305,385.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.245,448.773c15.144,73.894,21.344,94.178,42.507,94.372"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.07,538.255c-12.438,1.63-31.071,3.261-43.509,4.89-3.1,12.19-6.21,22.834-9.314,35.023"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.494,574.155c42.2,5.579,86.492,11.6,128.689,17.176-2.011,21.058-8.823,42.41-10.834,63.468-44.516-8.18-86.329-17.088-130.844-25.268C47.552,606.24,52.145,588.2,55.494,574.155Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.349,659.443c-18.142,90.683-31.765,153.9-38.694,160.99-35.217,25.113-71.822,32.834-83.579,34.056-23.341-6.9-42.43-34.03-45.973-54.965C0.4,771.724,33.555,674.37,47,628.842"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.784,820.1l70.925-66.476"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M594.451,828.134c-11.976,53.888-35.71,167.222-35.71,167.222H216.686l-7.739-360.681"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.928,167.426l29.751-.531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg389);
export default __webpack_public_path__ + "static/media/389.6cca42e1e15a11cbfad1ee2fdd1b8704.svg";
export { ForwardRef as ReactComponent };